import template from './awaitingreview.html';
import controller from './awaitingreview.controller';
import './awaitingreview.styl';

let awaitingreviewComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default awaitingreviewComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/awaitingreview/awaitingreview.component.js